<template>
  <div class="logo-menu">
    <nav
      class="navbar navbar-default affix-top"
      role="navigation"
      data-spy="affix"
      data-offset-top="50"
    >
      <div class="container">
        <div class="navbar-header">
          <button
            type="button"
            class="navbar-toggle"
            data-toggle="collapse"
            data-target="#navbar"
          >
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <a class="navbar-brand logo" href="/"
            ><img src="/img/logo_Kira-RH.png" alt="" width="200" height="60"
          /></a>
        </div>
        <div class="collapse navbar-collapse" id="navbar">
          <ul class="nav navbar-nav">
            <li class="drop">
              <a class="active" href="/"> Accueil </a>
            </li>
            <li class="drop">
              <a href="#"> Candidats <i class="fa fa-angle-down"></i> </a>
              <ul class="dropdown">
                <li>
                  <a href="/candidate/offers"> Offres d'emploi </a>
                </li>
                <li>
                  <a href="/candidate/my-applications"> Mes candidatures </a>
                </li>
                <li>
                  <a href="/candidate/my-account"> Mon compte </a>
                </li>
                <li>
                  <a href="/candidate/cv"> Publier mon CV </a>
                </li>
              </ul>
            </li>
            <li class="drop">
              <a href="#"> Employeurs <i class="fa fa-angle-down"></i> </a>
              <ul class="dropdown">
                <li>
                  <a href="/company/new/offer"> Publier une offre d'emploi </a>
                </li>
                <li>
                  <a href="/company/cv-theque"> CVthèque </a>
                </li>
                <li>
                  <a href="/company/offers"> Gérer mes offres d'emploi </a>
                </li>
                <li>
                  <a href="/company/my-account"> Mon espace employeur </a>
                </li>
              </ul>
            </li>
          </ul>
          <ul class="nav navbar-nav navbar-right float-right">
            <li class="left">
              <a href="/company/new/offer"
                ><i class="ti-pencil-alt"></i> Publier une offre</a
              >
            </li>
            <li class="right">
              <a href="/my-account"><i class="ti-lock"></i> Connexion</a>
            </li>
          </ul>
        </div>
      </div>

      <ul class="wpb-mobile-menu">
        <li>
          <a class="active" href="/"> Accueil </a>
        </li>
        <li>
          <a href="#">Candidats</a>
          <ul>
            <li>
              <a href="/candidate/offers"> Offres d'emploi </a>
            </li>
            <li>
              <a href="/candidate/my-applications"> Mes candidatures </a>
            </li>
            <li>
              <a href="/candidate/my-account"> Mon compte </a>
            </li>
            <li>
              <a href="/candidate/cv"> Publier mon CV </a>
            </li>
          </ul>
        </li>
        <li>
          <a href="#">Employeurs</a>
          <ul>
            <li>
              <a href="/company/new/offer"> Publier une offre d'emploi </a>
            </li>
            <li>
              <a href="/company/cv-theque"> CVthèque </a>
            </li>
            <li>
              <a href="/company/offers"> Gérer mes offres d'emploi </a>
            </li>
            <li>
              <a href="/company/my-account"> Mon espace employeur </a>
            </li>
          </ul>
        </li>
        <li class="btn-m">
          <a href="/company/new/offer"
            ><i class="ti-pencil-alt"></i> Publier une offre</a
          >
        </li>
        <li class="btn-m">
          <a href="/my-account"><i class="ti-lock"></i> Connexion</a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Menu",
};
</script>

<style scoped></style>
